import { EnumPaymentRequestStatuses } from '@dato-proxy/enums';
import { ServiceBagService, ServiceBagServices } from '@m4u-angular/base/component/ServiceBag';
import { BaseGridComponent } from '@m4u-angular/base/component/BaseGridComponent';
import { Component, Output, EventEmitter, Input } from '@angular/core';
import { BaseState } from '@m4u-angular/base/entities/BaseEntities';
import { PaymentRequest } from '@dato-proxy/entities/paymentrequest.entity';

@Component({
    providers: ServiceBagServices,
    selector: 'app-payment-request-grid',
    templateUrl: './payment-request-grid.component.html',
    styleUrls: ['./payment-request-grid.component.scss']
})
export class PaymentRequestGridComponent extends BaseGridComponent<PaymentRequest, BaseState> {

    @Output() PaymentRequestSelected: EventEmitter<PaymentRequest> = new EventEmitter<PaymentRequest>();
    @Output() ResolveClick: EventEmitter<PaymentRequest> = new EventEmitter<PaymentRequest>();

    constructor(A: ServiceBagService) {
        super(A, 'PaymentRequestGridComponent', PaymentRequest, BaseState);
    }

    GetStatusColor(data) {
        switch (data.Status) {
            case EnumPaymentRequestStatuses.Sent:
                return 'mango';
            case EnumPaymentRequestStatuses.Confirmed:
            case EnumPaymentRequestStatuses.Executed:
                return 'green-cyan';
            case EnumPaymentRequestStatuses.Resolved:
                return 'mango';
            case EnumPaymentRequestStatuses.Cancelled:
            case EnumPaymentRequestStatuses.Error:
                return 'cinnabar';
        }
    }

    OnPaymentRequestSelected(row) {
        this.PaymentRequestSelected.emit(row.data);
    }
    OnResolveClick(data) {
        this.ResolveClick.emit(data);
    }
}
